import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';

const BLUR_EVENT = 'blur';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';

class SchoolInputCode extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data, titleMarkup) {
		this.schoolInputCodeContainerClass = `lta-school-input-code-container-${data.id}`;
		const inputID = `lta-school-input-code-id-${data.id}`;
		const labelElement = `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${data.label}</label>`;
		return `<div class="lta-school-input-code">
					<div class="lta-school-input-code-title">${titleMarkup}</div>
					<div class="lta-school-input-code__wrapper lta-text-dob">
						<label for="" class="lta-school-input-code__label">
							${labelElement}
						</label>
						<div class="lta-text-input--error"></div>
						<div class="lta-school-input-code__text-wrapper u-hstack u-mb-3">
							<input type="number" class="lta-text-input" placeholder="00">
							<span class="lta-school-input-code__separator">-</span>
							<input type="number" class="lta-text-input" placeholder="00">
							<span class="lta-school-input-code__separator">-</span>
							<input type="number" class="lta-text-input" placeholder="00">
						</div>
					</div>
				</div>`;
	}
	afterRender() {
		this.componentElement = SelectorEngine.findOne('.lta-school-input-code',this._element);
		this.inputFieldContainerElement = SelectorEngine.findOne('.lta-school-input-code__wrapper', this._element);
		this.inputFieldElements = SelectorEngine.find('input', this.inputFieldContainerElement);
		for (const inputField of this.inputFieldElements) {
			EventHandler.on(inputField, BLUR_EVENT, () => {
				this.setupValueObject();
			});
		}
	}
	setupValueObject() {
		if(this.validate()) {
			const valueObject = [];
			for (const inputField of this.inputFieldElements) {
				valueObject.push(inputField.value);
			}
			this.value = {
				...this.data,
				value: valueObject.join('')
			}
			if(this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
		}
	}
	validate() {
		let isValidValue = true;
		for (const inputField of this.inputFieldElements) {
			if(!inputField.value || inputField?.value?.length !== 2) {
				isValidValue = false;
				break;
			}
		}
		if(isValidValue) {
			this.removeInvalidClass();
		} else {
			this.addInvalidClass();
		}
		return isValidValue;
	}

	removeInvalidClass() {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		errorElement.innerHTML = '';
		this.inputFieldContainerElement.classList.remove(IS_INVALID_CLASS);
    	this.inputFieldContainerElement.classList.remove(IS_FOCUSED_CLASS);
	}

	addInvalidClass() {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		errorElement.innerHTML = this.data?.errorMessage;
		this.inputFieldContainerElement.classList.add(IS_INVALID_CLASS);
    	this.inputFieldContainerElement.classList.add(IS_FOCUSED_CLASS);
	}
}
export default SchoolInputCode;
